import { logEvent } from "firebase/analytics";
import type { Analytics, EventParams } from "firebase/analytics";

/**
 * Safe wrapper for Firebase logEvent that checks if analytics is defined.
 * Prevents "Cannot read properties of undefined (reading 'app')" error
 * when analytics is not yet initialized.
 */
export function safeLogEvent(
  analytics: Analytics | undefined | null,
  eventName: string,
  eventParams?: EventParams,
): void {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
}
